import { InputModel, InputTypes, InputValue, } from '.';
import { BaseClass } from '../..';

export class InputClass extends BaseClass<InputModel> implements InputModel {
  get autocomplete(): string | undefined {
    return this.props.autocomplete;
  }
  get col(): number | undefined {
    return this.props.col;
  }
  get defaultValue(): InputValue | undefined {
    return this.props.defaultValue;
  }
  get disabled(): boolean {
    return this.props.disabled;
  }
  get error(): boolean {
    return this.props.error;
  }
  get errorMessage(): string | undefined {
    return this.props.errorMessage;
  }
  get label(): string | undefined {
    return this.props.label;
  }
  get name(): string {
    return this.props.name;
  }
  get placeholder(): string | undefined {
    return this.props.placeholder;
  }
  get required(): boolean {
    return this.props.required;
  }
  get type(): InputTypes {
    return this.props.type;
  }
  get validation(): string | undefined {
    return this.props.validation;
  }
  get value(): InputValue {
    return this.props.value;
  }
}
